import { Badge, type BadgeVariant } from "@/components/badge";

type DesignerSectionId =
  | "awaiting-reply"
  | "being-revised"
  | "in-progress"
  | "others"
  | "ready-for-review";

interface SectionTitleBadgeProps {
  sectionId: DesignerSectionId;
}

// Map section IDs to display labels and badge variants
// Based on status colors from shared/constants/statusColors.ts
const SECTION_BADGE_CONFIG: Record<
  DesignerSectionId,
  { label: string; variant: BadgeVariant }
> = {
  "awaiting-reply": { label: "Awaiting Reply", variant: "success" },
  "being-revised": { label: "Being Revised", variant: "pink" },
  "in-progress": { label: "In Progress", variant: "success" },
  others: { label: "Others", variant: "primary" },
  "ready-for-review": { label: "Ready for Review", variant: "warning" },
};

/**
 * Renders a section title as a larger status badge for Designer tables
 * Used to replace plain text section headers with styled badges
 */
export function SectionTitleBadge({ sectionId }: SectionTitleBadgeProps) {
  const config = SECTION_BADGE_CONFIG[sectionId];

  return (
    <Badge
      className="text-base px-4 py-1"
      isRounded
      size="medium"
      variant={config.variant}
    >
      {config.label}
    </Badge>
  );
}
